import React from "react";
import { FormattedMessage } from "react-intl";

import { DeviceWithType } from "../../../../components/devices/DeviceWithType";
import {
  singleDeviceIdSort,
  timeSort,
  showValue,
} from "../../../../components/table/helpers";
import { Manufacturer } from "../../../../components/manufacturer/Manufacturer";
import { DiscoveredDevicesDropdownActions, TableCard } from "./components";

export const COLUMNS = [
  {
    Header: <FormattedMessage id={"device_id_devices_table_header"} />,
    accessor: "id",
    Cell: ({
      row: {
        original: { type, id },
      },
    }) => {
      return <DeviceWithType type={type} identifier={id} />;
    },
    sortType: singleDeviceIdSort,
  },
  {
    Header: <FormattedMessage id={"manufacturer_devices_table_header"} />,
    accessor: "manufacturer",
    Cell: ({
      row: {
        original: { manufacturer },
      },
    }) => <Manufacturer manufacturer={manufacturer} />,
  },
  {
    Header: <FormattedMessage id={"last_seen_devices_table_header"} />,
    accessor: "lastSeen",
    sortType: timeSort,
    cellClassName: "color-table__cell",
    Cell: ({
      row: {
        original: { lastSeen },
      },
    }) => <div>{showValue(lastSeen)}</div>,
  },
  {
    id: "actions",
    sortable: false,
    headerClassName: "table__cell--small-cell",
    Header: <FormattedMessage id={"actions"} />,
    cellClassName: "table__cell--center table__cell--overflow",
    Cell: ({
      row: {
        original: { type, id, manufacturer },
      },
    }) => (
      <DiscoveredDevicesDropdownActions
        device={{ type, manufacturer, identifiers: [id] }}
      />
    ),
  },
];

export const COLUMNS_MOBILE = [
  {
    accessor: "id",
    cellClassName: "table__cell--overflow",
    SortingLabel: <FormattedMessage id={"device_id_devices_table_header"} />,
    Cell: ({
      row: {
        original: { type, manufacturer, id, lastSeen },
      },
    }) => (
      <TableCard
        type={type}
        manufacturer={manufacturer}
        identifier={id}
        lastSeen={lastSeen}
      />
    ),
    sortType: singleDeviceIdSort,
  },
  {
    accessor: "manufacturer",
    SortingLabel: <FormattedMessage id={"manufacturer_devices_table_header"} />,
  },
  {
    accessor: "lastSeen",
    sortType: timeSort,
    SortingLabel: <FormattedMessage id={"last_seen_devices_table_header"} />,
  },
];

export const SEARCH_KEYS = ["id", "lastSeen", "manufacturer"];

export const INITIAL_SORT = [{ id: "lastSeen", desc: true }];

export const SUB_HEADER = <FormattedMessage id={"refresh_to_see_devices"} />;
